const translateBillingsFr = {
  billings: {
    show: {
      title: "Afficher les factures",
    },
  },
};

export default translateBillingsFr;
